import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { CreateProcedureTypeViewTopBar } from "./TopBar"

export const createProcedureTypeViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: CreateProcedureTypeViewTopBar,
}
